// function sizingAllRowOnHover() {
//   const getAllCollectionProductCard = document.querySelectorAll('.product-card');
//   getAllCollectionProductCard.forEach((card) => {
//     card.addEventListener('mouseover', () => {
//       getAllCollectionProductCard.forEach((item) => {

//         if (card.offsetTop == item.offsetTop) {
//           item.classList.add('product-card--sized');
//         } else {
//           item.classList.remove('product-card--sized');
//         }

//         card.addEventListener('mouseout', (e) => {
//           item.classList.remove('product-card--sized')
//         })

//       });

//     });
//   });
// }

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function formatPrice(input) {
  return (input / 100).toFixed(2).toString().replace(".", ",") + " €";
  return (input / 100).toFixed(2).toString().replace(".", ",") + " €";
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function addToCartOpenDrawer(variantId, quantity) {
  addToCart(variantId, quantity).then(() => {
    openCartDrawerV2();
  });
}

function saveObjectToLocalStorage(key, obj) {
  localStorage.setItem(key, JSON.stringify(obj));
}

function loadObjectFromLocalStorage(key) {
  return JSON.parse(localStorage.getItem(key));
}

function getCurrentWishlist() {
  return loadObjectFromLocalStorage("purish_wishlist_v2") || [];
}

function removeFromWishlist(variantId) {
  const currentWishlist = getCurrentWishlist();
  const newWishlist = currentWishlist.filter(
    (wishlistItem) => wishlistItem.variantId != variantId,
  );
  saveObjectToLocalStorage("purish_wishlist_v2", newWishlist);
}

function addToWishlist(
  title,
  variantId,
  imgUrl,
  productUrl,
  productHandle,
  productCurrency,
  isWishlistVariantType,
) {
  const currentWishlist = getCurrentWishlist();

  const exists = currentWishlist.some(
    (wishlistItem) => wishlistItem.variantId == variantId,
  );

  if (!exists) {
    currentWishlist.push({
      title,
      variantId,
      imgUrl,
      productUrl,
      productHandle,
      productCurrency,
      isWishlistVariantType,
    });
    saveObjectToLocalStorage("purish_wishlist_v2", currentWishlist);
  }
}

async function addToCart(variantId, quantity) {
  const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: quantity,
        },
      ],
    }),
  });

  console.log(res);
  return res;
}

async function setDiscountCode(discountCode) {
  const discountUrl = "/discount/" + discountCode;
  console.log("Activating discount " + discountCode);
  return fetch(discountUrl);
}

async function setLanguage(languageCode) {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = "/localization";

  const fields = {
    language_code: languageCode,
    form_type: "localization",
    _method: "put",
    utf8: "✓",
  };

  for (const name in fields) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = fields[name];
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
}

function switchLanguage() {
  const currentLocale = Shopify.locale;

  if (currentLocale === "en") {
    setLanguage("de");
  } else {
    setLanguage("en");
  }
}

class ProductQuantity extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    event.preventDefault();

    if (this.input.value === this.input.max) {
      alert(
        "Es tut uns leid, aber du kannst momentan keine höhere Anzahl auswählen",
      );
    }

    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("product-quantity", ProductQuantity);

class Accordion extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector(".accordion__toggle");
    this.content = this.querySelector(".accordion__content");
    this.isActive = this.button.classList.contains("is-active");

    this.button.addEventListener("click", () => this.handleToggle());
  }

  handleToggle() {
    this.setState(!this.isActive);

    Array.from(this.parentElement.querySelectorAll("custom-accordion"))
      .filter((item) => item != this)
      .forEach((item) => item.setState(false));
  }

  setState(state) {
    this.isActive = state;
    if (state) {
      this.button.classList.add("is-active");
      this.content.classList.add("is-active");
    } else {
      this.button.classList.remove("is-active");
      this.content.classList.remove("is-active");
    }
  }
}

customElements.define("custom-accordion", Accordion);

class WishlistIcon extends HTMLElement {
  constructor() {
    super();

    this.title = this.getAttribute("data-title");
    this.variantId = this.getAttribute("data-variant-id");
    this.imgUrl = this.getAttribute("data-img-url");
    this.productUrl = this.getAttribute("data-product-url");
    this.productHandle = this.getAttribute("data-product-handle");
    this.productCurrency = this.getAttribute("data-product-currency");

    this.iconAdd = this.querySelector(".template-product__wishlist-icon--add");
    this.iconAdded = this.querySelector(
      ".template-product__wishlist-icon--added",
    );

    this.addEventListener("click", () => {
      this.onClick();
    });

    const currentWishlist = getCurrentWishlist();
    this.status = currentWishlist.some(
      (wishlistItem) => wishlistItem.variantId == this.variantId,
    );

    if (this.status) {
      this.activate();
    }
  }

  onClick() {
    if (this.status) {
      this.deactivate();
    } else {
      fireCustomGA4Event("add_to_wishlist");
      this.activate();
    }
  }

  activate() {
    addToWishlist(
      this.title,
      this.variantId,
      this.imgUrl,
      this.productUrl,
      this.productHandle,
      this.productCurrency,
      false,
    );
    this.classList.add("is-saved");
    this.status = true;
  }

  deactivate() {
    removeFromWishlist(this.variantId);
    fireCustomGA4Event("remove_from_wishlist");
    this.classList.remove("is-saved");
    this.status = false;
  }
}

customElements.define("wishlist-icon", WishlistIcon);

if (!customElements.get("filters-mobile")) {
  class FiltersMobile extends HTMLElement {
    constructor() {
      super();

      this.openButton = document.querySelector(".filters-button-mobile");

      this.tabsButton = this.querySelectorAll(".filters-mobile__tab-button");
      this.tabsContent = this.querySelectorAll(".filters-mobile__tab-content");
      this.closeButton = this.querySelector(".filters-mobile__close");
      this.checkboxes = this.querySelectorAll(
        ".filters-mobile__field-checkbox",
      );
      this.applyButtons = this.querySelectorAll(".filters-mobile__apply");
      this.filterButton = document.querySelector(".filters-button-mobile");
      this.clearButton = this.querySelector(".filters-mobile__clear");

      this.filterForm = this.querySelector("filter-form-collection");
      this.priceRange = this.querySelector("price-range");

      this.openButton.addEventListener("click", () => {
        this.openFilters();
      });

      this.tabsButton.forEach((button) => {
        button.addEventListener("click", () => {
          this.toggle(button);
        });
      });

      this.closeButton.addEventListener("click", () => {
        this.closeFilters();
      });

      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", async () => {
          await this.filterForm.render();
          this.updateProductCount();
        });
      });

      this.applyButtons.forEach((apply) => {
        apply.addEventListener("click", async () => {
          this.closeFilters();
        });
      });

      this.clearButton.addEventListener("click", async () => {
        this.clearCheckboxes();
        this.closeFilters();
        this.priceRange.setDefaultRangePrice();
        await this.filterForm.render();
      });
    }

    updateProductCount() {
      let productCount = parseInt(
        document.querySelector("[data-type='Collection']").dataset.productCount,
      );
      productCount = productCount > 99 ? "99+" : productCount;
      this.applyButtons.forEach((button) => {
        button.textContent = `${productCount} Produkte anzeigen`;
      });

      const filterCount = [...this.checkboxes].filter(
        (check) => check.checked,
      ).length;
      if (filterCount > 0) {
        this.filterButton.classList.add("filters-button-mobile-active");
      } else {
        this.filterButton.classList.remove("filters-button-mobile-active");
      }
    }

    toggle(button) {
      if (!button.hasAttribute("data-toggled")) {
        this.closeTabs();
        button.setAttribute("data-toggled", "");
        button.nextElementSibling.setAttribute("data-toggled", "");
      } else {
        this.closeTabs();
        button.removeAttribute("data-toggled");
        button.nextElementSibling.removeAttribute("data-toggled");
      }
    }

    closeTabs() {
      this.tabsButton.forEach((b) => {
        b.setAttribute("data-toggled", "");
      });
      this.tabsContent.forEach((c) => {
        c.setAttribute("data-toggled", "");
      });
    }

    closeFilters() {
      this.setAttribute("data-toggled", "");
      document.body.removeAttribute("data-toggled");
    }

    clearCheckboxes() {
      this.checkboxes.forEach((checkbox) => (checkbox.checked = false));
    }

    openFilters() {
      this.removeAttribute("data-toggled");
      document.body.setAttribute("data-toggled", "");
    }
  }

  customElements.define("filters-mobile", FiltersMobile);
}

if (!customElements.get("filters-desktop")) {
  class FiltersDesktop extends HTMLElement {
    constructor() {
      super();
      this.selectButtons = this.querySelectorAll(
        ".filters-desktop__select-button",
      );
      this.selectDropdowns = this.querySelectorAll(
        ".filters-desktop__select-dropdown",
      );
      this.checkboxes = this.querySelectorAll(
        ".filters-desktop__field-checkbox",
      );
      this.applyButtons = this.querySelectorAll(
        ".filters-desktop__select-apply",
      );
      this.clearButtons = this.querySelectorAll(
        ".filters-desktop__select-clear",
      );
      this.fields = this.querySelectorAll(".filters-desktop__field");

      this.filtersButtonDesktop = document.querySelector(
        ".filters-button-desktop",
      );
      this.filtersButtonDesktopCount = this.filtersButtonDesktop.querySelector(
        ".filters-button-desktop__count",
      );

      this.count = document.querySelector(".filters-button-desktop__count");

      this.filterForm = this.querySelector("filter-form-collection");
      this.priceRange = this.querySelector("price-range");

      this.selectedFiltersSize();

      this.filtersButtonDesktop.addEventListener("click", async () => {
        if (this.priceRange) {
          this.priceRange.setDefaultRangePrice();
        }

        this.checkboxes.forEach((checkbox) => (checkbox.checked = false));
        this.filtersButtonDesktopCount.textContent = "(0)";

        await this.filterForm.render();
      });

      this.selectButtons.forEach((button) => {
        button.addEventListener("click", () => {
          this.toggle(button);
        });
        button.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            this.toggle(button);
          }
        });
      });

      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", () => {
          // this.selectedFiltersSize();
          this.filterForm.render();
        });
      });

      this.fields.forEach((field) => {
        field.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            field.querySelector("input").checked = true;
            this.filterForm.render();
          }
        });
      });

      this.applyButtons.forEach((apply) => {
        apply.addEventListener("click", async () => {
          this.closeDropdown();
        });
      });

      this.clearButtons.forEach((clear) => {
        clear.addEventListener("click", async () => {
          this.clearCheckboxes(clear);
          this.closeDropdown();
          await this.filterForm.render();
        });
      });

      document.addEventListener("click", (e) => {
        if (e.target.closest(".filters-desktop") == null) {
          this.closeDropdown();
        }
      });
    }

    toggle(button) {
      if (!button.hasAttribute("data-toggled")) {
        this.closeDropdown();
        button.setAttribute("data-toggled", "");
        button.nextElementSibling.setAttribute("data-toggled", "");
      } else {
        this.closeDropdown();
        button.removeAttribute("data-toggled");
        button.nextElementSibling.removeAttribute("data-toggled");
        setTimeout(() => {
          button.nextElementSibling.focus();
          console.log("FOcus on", button.nextElementSibling);
        }, 300);
      }
    }

    closeDropdown() {
      this.selectButtons.forEach((b) => {
        b.setAttribute("data-toggled", "");
      });
      this.selectDropdowns.forEach((d) => {
        d.setAttribute("data-toggled", "");
      });
    }

    clearCheckboxes(clear) {
      let parent = clear.closest(".filters-desktop__select-dropdown");
      parent.querySelectorAll("input").forEach((input) => {
        input.checked = false;
      });
    }

    selectedFiltersSize() {
      let count = [...this.checkboxes].filter((check) => check.checked).length;
      if (
        this.priceRange &&
        !this.priceRange
          .querySelector(".price-range__input")
          .hasAttribute("disabled")
      ) {
        count++;
      }

      this.count.textContent = `(${count})`;
    }
  }

  customElements.define("filters-desktop", FiltersDesktop);
}

if (!customElements.get("filter-form-collection")) {
  class FilterFormCollection extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");

      this.checkboxes = this.querySelectorAll(".filters-active__checkbox");

      this.priceItem = this.querySelector("div.filters-active__item");

      this.getAllFilters = document.querySelectorAll("[data-filter-value]");
      this.priceRanges = document.querySelectorAll("price-range");
      this.filtersDesktop = document.querySelector("filters-desktop");

      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", async () => {
          this.removeFilter(checkbox);
          this.filtersDesktop.selectedFiltersSize();
          await this.render();
        });
      });

      if (this.priceItem) {
        this.priceItem.addEventListener("click", async () => {
          this.setDefaultPrice();
          this.priceRanges[0].setDefaultRangePrice();
          this.priceRanges[1].setDefaultRangePrice();
          this.filtersDesktop.selectedFiltersSize();
          await this.render();
        });
      }
    }

    removeFilter(checkbox) {
      this.getAllFilters.forEach((filter) => {
        if (filter.value === checkbox.value) {
          filter.checked = false;
        }
      });
    }
    setDefaultPrice() {
      const inputMin = this.priceItem.firstElementChild;
      const inputMax = inputMin.nextElementSibling;
      inputMin.value = this.priceItem.dataset.min;
      inputMax.value = this.priceItem.dataset.max;
      inputMin.setAttribute("disabled", "");
      inputMax.setAttribute("disabled", "");
    }

    async render() {
      const newHTML = await this.fetchSection();
      const parser = new DOMParser();
      let resAsHtml = parser.parseFromString(newHTML, "text/html");
      const updatedCart = resAsHtml.querySelector(".new-collection__wrapper");
      const currentContent = document.querySelector(".new-collection__inner");
      const newContent = updatedCart.querySelector(".new-collection__inner");

      if (currentContent.innerHTML === newContent.innerHTML) return;

      document
        .querySelector(".new-collection__wrapper")
        .setAttribute("data-product-count", updatedCart.dataset.productCount);

      this.saveCurrentState(currentContent, newContent);

      currentContent.innerHTML = newContent.innerHTML;

      this.updateUrl();
      this.loadScrollState();
    }

    saveCurrentState(currentContent, newContent) {
      const currentFilterDropdowns = currentContent.querySelectorAll(
        ".filters-desktop__select-dropdown",
      );
      const newFilterDropdowns = newContent.querySelectorAll(
        ".filters-desktop__select-dropdown",
      );

      currentFilterDropdowns.forEach((currentFilterDropdown, index) => {
        // If it has data-toggled, it is not opened
        if (currentFilterDropdown.hasAttribute("data-toggled")) {
          return;
        }
        const newFilterDropdown = newFilterDropdowns[index];
        // Open new dropdown
        newFilterDropdown.removeAttribute("data-toggled");

        const currentFilterDropdownContent =
          currentFilterDropdown.querySelector(
            ".filters-desktop__select-content",
          );
        const newFilterDropdownContent = newFilterDropdown.querySelector(
          ".filters-desktop__select-content",
        );

        // Save state as data attribute
        if (currentFilterDropdownContent && newFilterDropdownContent) {
          newFilterDropdownContent.setAttribute(
            "data-scroll-top-to",
            currentFilterDropdownContent.scrollTop,
          );
        }
      });

      const currentFilterTabs = currentContent.querySelectorAll(
        ".filters-mobile__tab",
      );
      const newFilterTabs = newContent.querySelectorAll(".filters-mobile__tab");

      currentFilterTabs.forEach((currentFilterTab, index) => {
        const newFilterTab = newFilterTabs[index];

        if (!currentFilterTab.querySelector("[data-toggled]")) {
          newFilterTab.querySelectorAll("[data-toggled]").forEach((element) => {
            element.removeAttribute("data-toggled");
          });

          const currentFilterTabContent = currentFilterTab.querySelector(
            ".filters-mobile__tab-content",
          );
          const newFilterTabContent = newFilterTab.querySelector(
            ".filters-mobile__tab-content",
          );

          if (currentFilterTabContent && newFilterTabContent) {
            newFilterTabContent.setAttribute(
              "data-scroll-top-to",
              currentFilterTabContent.scrollTop,
            );
          }
        }
      });

      const currentFiltersMobile =
        currentContent.querySelector("filters-mobile");
      if (
        currentFiltersMobile &&
        !currentFiltersMobile.hasAttribute("data-toggled")
      ) {
        const newFiltersMobile = newContent.querySelector("filters-mobile");
        newFiltersMobile.removeAttribute("data-toggled");
      }
    }

    loadScrollState() {
      document.querySelectorAll("[data-scroll-top-to]").forEach((element) => {
        element.scrollTop = parseInt(element.dataset.scrollTopTo);
        console.log(element, element.dataset.scrollTopTo);
      });
    }

    async fetchSection() {
      const url = `${
        window.location.pathname
      }?${this.getSearchParams()}&section_id=${this.dataset.id}`;
      const res = await fetch(url);
      const text = await res.text();
      return text;
    }

    getSearchParams() {
      const formData = new FormData(this.form);
      const urlParams = new URLSearchParams(window.location.search);
      Array.from(urlParams.entries()).forEach((entry) => {
        const key = entry[0];
        if (key.includes("filter") || key === "page") {
          urlParams.delete(key);
        }
      });
      for (var pair of formData.entries()) {
        urlParams.append(pair[0], pair[1]);
      }
      return urlParams.toString();
    }

    updateUrl() {
      let searchParams = this.getSearchParams();
      history.pushState(
        { searchParams },
        "",
        `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
      );
    }
  }

  customElements.define("filter-form-collection", FilterFormCollection);
}

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.productPrice = this.querySelector("product-price");
    this.cta = this.querySelector(".product-card__cta[data-available]");
    this.swatches = Array.from(this.querySelectorAll("[data-card-variant]"));

    this.registerCta();
    this.registerSwatches();
    this.showStellaIcon();
  }

  // One button, two states — see snippets/product-card-cta.liquid.
  registerCta() {
    if (!this.cta) {
      return;
    }

    this.cta.addEventListener("click", async () => {
      if (this.cta.dataset.available !== "true") {
        // Sold out with no reminder to offer: the button renders as an inert
        // "Ausverkauft" label, so it must not report a click either.
        if (this.cta.dataset.backInStock !== "true") {
          return;
        }
        fireCustomGA4Event("click_back_in_stock");
        this.openBackInStock();
        return;
      }

      fireCustomGA4Event("click_product_card_atc");

      const variantId = parseInt(this.cta.dataset.productId);

      // If price is displayed with sitecode information, set the sitecode before so that cart price matches price shown in product-card
      if (this.productPrice) {
        const matchingSitecode = this.productPrice.dataset.matchingSitecode;
        if (matchingSitecode && matchingSitecode !== "") {
          await setDiscountCode(matchingSitecode);
        }
      }
      await addToCartOpenDrawer(variantId, 1);
    });
  }

  // Scoped to this card so a duplicate card elsewhere on the page (e.g. in a
  // closed megamenu panel) can't have its hidden modal opened instead.
  openBackInStock() {
    const modal = this.querySelector(
      "custom-modal[data-modal-id^='back-in-stock-']",
    );
    if (!modal) {
      return;
    }

    const variantSelect = modal.querySelector(".back-in-stock-form__variant");
    const variantId = this.cta?.dataset.productId;
    if (variantSelect && variantId) {
      const hasOption = Array.from(variantSelect.options).some(
        (option) => option.value === variantId,
      );
      if (hasOption) {
        variantSelect.value = variantId;
      }
    }

    modal.show();
  }

  registerSwatches() {
    this.swatches.forEach((swatch) => {
      swatch.addEventListener("click", () => this.selectVariant(swatch));
    });
  }

  // Everything the card shows for a variant — image, price, links, add-to-cart
  // target — comes from the data attributes the swatch carries, so picking a
  // shade costs no request.
  selectVariant(swatch) {
    const variant = swatch.dataset;

    this.swatches.forEach((item) => {
      const isActive = item === swatch;
      item.dataset.active = String(isActive);
      item.setAttribute("aria-pressed", String(isActive));
    });

    if (variant.image) {
      // Only the first slide belongs to the selected variant; the rest of the
      // slider stays as rendered (see snippets/product-card-media.liquid).
      const mediaImages = this.querySelectorAll(
        ".product-card-image > img:first-of-type",
      );
      mediaImages.forEach((image) => {
        image.removeAttribute("srcset");
        image.src = variant.image;
      });

      this.querySelector(".card-slider__list")?.scrollTo({
        left: 0,
        behavior: "smooth",
      });
    }

    if (variant.url) {
      this.querySelectorAll("a.product-card-title, a.product-card-image").forEach(
        (link) => (link.href = variant.url),
      );
    }

    this.productPrice?.setVariant({
      price: parseInt(variant.price),
      compareAtPrice: parseInt(variant.compareAtPrice) || null,
      displayPrice: parseInt(variant.displayPrice),
    });

    if (this.cta) {
      this.cta.dataset.productId = variant.variantId;
      this.cta.dataset.available = variant.available;
    }
  }

  showStellaIcon() {
    const variantIds = this.dataset.variantIds.split(",");
    for (const variantId of variantIds) {
      if (variantIdRecommendedByStella(variantId)) {
        // The Stella badge markup is currently commented out in
        // snippets/product-card-media.liquid, so there may be nothing to mark.
        const stellaBadge = this.querySelector(".product-card--stella");
        if (stellaBadge) {
          stellaBadge.dataset.stellaSelected = true;
        }
      }
    }
  }
}

customElements.define("product-card", ProductCard);

// Two row-level passes over the product-card grid, both keyed off the row a
// card sits in: drop the variant row where a whole row has nothing to put in
// it, then align the titles below it so the prices share a baseline.
(function alignProductCardRows() {
  const CARD_SELECTOR = ".product-card--default";
  let queued = false;

  // The row reserves its height even when a card has no choice to offer
  // (see snippets/product-card-variants.liquid), so "empty" means no swatch
  // and no link to the rest of the variants — not an absent element.
  function hasVariantChoices(card) {
    const row = card.querySelector(".product-card-variants");
    if (!row) return false;
    return (
      row.querySelector(
        "[data-card-variant], .product-card-variants__more",
      ) !== null
    );
  }

  function align() {
    queued = false;
    const cards = document.querySelectorAll(CARD_SELECTOR);
    if (!cards.length) return;

    // Reset both passes to their natural state, then keep only the cards
    // actually rendered (skips e.g. cards inside closed megamenu panels).
    const visible = [];
    cards.forEach((card) => {
      delete card.dataset.variantsCollapsed;
      const title = card.querySelector(".product-card-title");
      if (title) title.style.height = "";
      if (card.offsetParent !== null) visible.push(card);
    });

    // Group the cards by the row they belong to (their top position). A row
    // collapses as a whole, so this grouping still holds after the first pass
    // writes: every card in a row shifts by the same amount.
    const rows = new Map();
    visible.forEach((card) => {
      const top = Math.round(card.getBoundingClientRect().top + window.scrollY);
      let group = rows.get(top);
      if (!group) rows.set(top, (group = []));
      group.push(card);
    });
    const groups = [...rows.values()];

    // Pass 1 — the variant row is what keeps a mixed row's titles and prices
    // level, so it stays as soon as one card in the row has variants to show.
    // When none of them does it lines nothing up and is only white space
    // between the image and the vendor: collapse it (see beautifuynew.css).
    groups.forEach((group) => {
      if (group.some(hasVariantChoices)) return;
      group.forEach((card) => (card.dataset.variantsCollapsed = "true"));
    });

    // Pass 2 — titles have no fixed height (see critical.css); here every title
    // in the same row grows to the tallest title in that row. An all-single-line
    // row stays compact, while a row containing a wrapping title reserves the
    // same height for all of its cards, keeping their prices lined up.
    const titles = groups.map((group) =>
      group
        .map((card) => card.querySelector(".product-card-title"))
        .filter(Boolean),
    );

    // Measure every row's tallest title first, then apply, to avoid layout
    // thrashing from interleaved reads and writes.
    const maxHeights = titles.map((group) =>
      group.reduce((max, title) => Math.max(max, title.offsetHeight), 0),
    );
    titles.forEach((group, index) => {
      group.forEach((title) => (title.style.height = maxHeights[index] + "px"));
    });
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(align);
  }

  queue();
  window.addEventListener("resize", queue);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(queue);
  }

  // Re-run when cards are added or removed (carousels cloning slides, collection
  // filters re-rendering, quick-add, etc.).
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length || mutation.removedNodes.length) {
        queue();
        return;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();

async function saveSitecode() {
  const urlParams = new URLSearchParams(window.location.search);
  const siteCode = urlParams.get("sitecode");

  if (siteCode) {
    localStorage.setItem(
      "sitecode_v2",
      JSON.stringify({
        code: siteCode,
        savedAt: Date.now(),
      }),
    );
    await setDiscountCode(siteCode);
    document.querySelectorAll("product-price").forEach((price) => {
      price.updateActivateState(siteCode);
    });
  }
}

saveSitecode();

function fireCustomGA4Event(eventName, parameters) {
  if (gtag) {
    if (parameters && typeof parameters === "string") {
      // Real JSON first, so values containing an apostrophe survive; the
      // legacy single-quoted form is only the fallback.
      try {
        parameters = JSON.parse(parameters);
      } catch (e) {
        parameters = JSON.parse(parameters.replaceAll("'", '"'));
      }
    }
    gtag("event", eventName, parameters);
    console.log(
      `[TRACKING] "${eventName}" with parameters:`,
      JSON.stringify(parameters),
    );
  }
}

function registerCustomGa4EventElements() {
  const ga4EventElements = document.querySelectorAll(
    "[data-ga4-event-name]:not([data-ga4-event-registered='true'])",
  );
  ga4EventElements.forEach((element) => {
    const eventName = element.dataset.ga4EventName;
    const eventParameters = element.dataset.ga4EventParameters;
    element.setAttribute("data-ga4-event-registered", true);
    element.addEventListener("click", () => {
      fireCustomGA4Event(eventName, eventParameters);
    });
  });
}

registerCustomGa4EventElements();

class ProductPrice extends HTMLElement {
  constructor() {
    super();

    this.originalPrice = parseInt(this.dataset.ogPrice);
    this.compareAtPrice = this.dataset.ogCompareAtPrice;
    this.discountBadge = this.querySelector(".product-price__discount");
    if (this.compareAtPrice) {
      this.compareAtPrice = parseInt(this.compareAtPrice);
    }

    if (this.dataset.nonDefaultSitecodes) {
      this.nonDefaultSitecodes = JSON.parse(this.dataset.nonDefaultSitecodes);
      this.currentActiveDiscounts = this.dataset.currentDiscountList.split(",");
      this.sitecodeMode = this.dataset.sitecodeMode;
      this.activateButton = this.querySelector(
        ".product-price__inner-sitecode-bottom-button",
      );

      this.setupSitecodeSystem();
    }
  }

  updateActivateState(activeSitecode) {
    const sitecodeEl = this.querySelector(
      ".product-price__inner-sitecode-info-label-copy b",
    );
    if (!sitecodeEl) {
      return;
    }
    const sitecode = sitecodeEl.textContent.trim().toUpperCase();
    if (!sitecode || sitecode === "") {
      return;
    }

    if (this.activateButton && sitecode === activeSitecode.toUpperCase()) {
      this.activateButton.setAttribute("data-state", "activated");
    }
  }

  // The code shown in the sitecode banner can be copied by clicking it. The
  // banner is rendered server-side for a default sitecode and filled in by
  // setupSitecodeBadge for a saved one, so register this once up front and
  // read the code at click time.
  registerCopySitecodeButton() {
    if (this.sitecodeMode !== "product-page") {
      return;
    }

    const copySitecodeEl = this.querySelector(
      ".product-price__inner-sitecode-info-label-copy",
    );
    if (!copySitecodeEl) {
      return;
    }

    copySitecodeEl.addEventListener("click", async () => {
      const textToCopy = copySitecodeEl.textContent.trim();
      if (!textToCopy) {
        return;
      }

      try {
        await navigator.clipboard.writeText(textToCopy);
        alert("Du hast den Code " + textToCopy + " kopiert.");
      } catch (error) {
        console.error("Failed to copy text to clipboard: " + error);
      }
    });
  }

  registerActivateButton() {
    const sitecodeEl = this.querySelector(
      ".product-price__inner-sitecode-info-label-copy b",
    );
    const sitecode = sitecodeEl.textContent.trim().toUpperCase();

    this.activateButton.addEventListener("click", async () => {
      await setDiscountCode(sitecode);
      this.activateButton.setAttribute("data-state", "activated");
    });

    const discountIsActive = this.currentActiveDiscounts.some(
      (discount) => discount.toUpperCase() === sitecode.toUpperCase(),
    );
    if (discountIsActive) {
      this.activateButton.setAttribute("data-state", "activated");
    }
  }

  setupSitecodeSystem() {
    this.registerCopySitecodeButton();

    const saved = this.resolveSavedSitecode();
    if (saved) {
      this.applySavedSitecode(saved.code, saved.sitecode);
    }

    this.registerActivateButton();
  }

  // Reads the saved sitecode and picks the best one that applies to this
  // product, or null when none does. Split out of setupSitecodeSystem so
  // setVariant can re-run it after the shown variant changes.
  resolveSavedSitecode() {
    const savedSitecodeJson = localStorage.getItem("sitecode_v2");

    if (!savedSitecodeJson) {
      return null;
    }

    const savedSitecodeParsed = JSON.parse(savedSitecodeJson);
    const savedSitecode = savedSitecodeParsed.code;
    const savedSitecodeAt = savedSitecodeParsed.savedAt;

    const deleteCodeAfter = 1000 * 60 * 60 * 24 * 7;
    if (Date.now() - savedSitecodeAt > deleteCodeAfter) {
      localStorage.removeItem("sitecode_v2");
      return null;
    }

    const matchingSitecodes = this.nonDefaultSitecodes.filter(
      (site) => site.code.toUpperCase() === savedSitecode.toUpperCase(),
    );

    if (matchingSitecodes.length == 0) {
      return null;
    }

    let matchingSitecode = matchingSitecodes[0];

    for (let sitecode of matchingSitecodes) {
      if (sitecode.discount_percentage > matchingSitecode.discount_percentage) {
        matchingSitecode = sitecode;
      }
    }

    return { code: savedSitecode, sitecode: matchingSitecode };
  }

  applySavedSitecode(savedSitecode, matchingSitecode) {
    this.setAttribute("data-matching-sitecode", matchingSitecode.code);

    if (this.discountBadge) {
      this.discountBadge.style.display = "none";
    }

    var newProductPrice = Math.ceil(
      this.originalPrice * (1 - matchingSitecode.discount_percentage),
    );

    if (matchingSitecode.discount_value != 0) {
      newProductPrice =
        this.originalPrice - parseInt(matchingSitecode.discount_value * 100);
    }

    const newCompareAtPrice = this.compareAtPrice
      ? this.compareAtPrice
      : this.originalPrice;

    if (this.sitecodeMode === "product-card") {
      this.adjustPriceToSitecode(
        newProductPrice,
        newCompareAtPrice,
        savedSitecode,
        matchingSitecode,
      );
    } else if (this.sitecodeMode == "product-page") {
      this.setupSitecodeBadge(
        newProductPrice,
        newCompareAtPrice,
        savedSitecode,
        matchingSitecode,
      );
    }
  }

  // Product cards only: re-render the price for the variant the shopper just
  // picked in the card's swatch row (see ProductCard.selectVariant).
  // `displayPrice` is what Liquid would have rendered for that variant, i.e.
  // with an active-by-default sitecode already folded in; a saved sitecode is
  // then re-applied on top exactly as on first load.
  setVariant({ price, compareAtPrice, displayPrice }) {
    this.originalPrice = price;
    this.compareAtPrice = compareAtPrice || null;
    this.dataset.ogPrice = price;
    this.dataset.ogCompareAtPrice = compareAtPrice || "";

    this.renderCardPrice(
      Number.isFinite(displayPrice) ? displayPrice : price,
      compareAtPrice || price,
    );

    if (this.sitecodeMode !== "product-card" || !this.nonDefaultSitecodes) {
      return;
    }

    const saved = this.resolveSavedSitecode();
    if (saved) {
      this.applySavedSitecode(saved.code, saved.sitecode);
    } else {
      this.removeAttribute("data-matching-sitecode");
    }
  }

  renderCardPrice(shownPrice, compareAtPrice) {
    const priceEl = this.querySelector(
      ".product-price__container > span.product-card-price",
    );

    if (!priceEl) {
      return;
    }

    const showCompareAtPrice = compareAtPrice > shownPrice;

    priceEl.textContent = formatPrice(shownPrice);
    priceEl.setAttribute("data-has-sale", showCompareAtPrice);

    const compareAtPriceEl = this.querySelector(".product-card-price--compare-at");
    if (compareAtPriceEl) {
      compareAtPriceEl.textContent = formatPrice(compareAtPrice);
      compareAtPriceEl.hidden = !showCompareAtPrice;
    }

    this.updateCardDiscountBadge(shownPrice);
  }

  setupSitecodeBadge(
    newProductPrice,
    newCompareAtPrice,
    savedSitecode,
    matchingSitecode,
  ) {
    const badgeWrapper = this.querySelector(
      ".product-price__inner-sitecode-wrapper",
    );

    const newProductPriceEl = this.querySelector(
      ".product-price__inner-sitecode-price",
    );
    const sitecodeEl = this.querySelector(
      ".product-price__inner-sitecode-info-label-copy b",
    );
    const savePercentageEl = this.querySelector(
      ".product-price__inner-sitecode-right p",
    );

    let newSavedPercentage = matchingSitecode.discount_percentage * 100;

    if (this.compareAtPrice && this.compareAtPrice > newProductPrice) {
      newSavedPercentage = (newProductPrice / this.compareAtPrice) * 100;
      newSavedPercentage = Math.round(newSavedPercentage);
      newSavedPercentage = 100 - newSavedPercentage;
    }

    newProductPriceEl.textContent = formatPrice(newProductPrice);
    sitecodeEl.textContent = savedSitecode;
    savePercentageEl.textContent = "-" + newSavedPercentage + "%";

    badgeWrapper.setAttribute("data-show", "true");
  }

  adjustPriceToSitecode(
    newProductPrice,
    newCompareAtPrice,
    savedSitecode,
    matchingSitecode,
  ) {
    // Product cards (snippets/product-card-price.liquid) use different price
    // markup than the product page, so resolve the card variant first.
    const cardPriceEl = this.querySelector(
      ".product-price__container > span.product-card-price",
    );
    const priceEl =
      cardPriceEl || this.querySelector(".product-price__sale-price span");

    if (!priceEl) {
      return;
    }

    priceEl.textContent = formatPrice(newProductPrice);

    const showCompareAtPrice = newProductPrice < newCompareAtPrice;

    if (cardPriceEl) {
      cardPriceEl.setAttribute("data-has-sale", showCompareAtPrice);

      const cardCompareAtPrice = this.querySelector(
        ".product-card-price--compare-at",
      );
      if (cardCompareAtPrice) {
        cardCompareAtPrice.textContent = formatPrice(newCompareAtPrice);
        cardCompareAtPrice.hidden = !showCompareAtPrice;
      }
    } else {
      const compareAtPrice = this.querySelector(
        ".product-price__original-price",
      );
      if (compareAtPrice) {
        if (showCompareAtPrice) {
          compareAtPrice.textContent = formatPrice(newCompareAtPrice);
          compareAtPrice.classList.remove("product-price__original-price-empty");
        } else {
          compareAtPrice.textContent = "";
          compareAtPrice.classList.add("product-price__original-price-empty");
        }
      }
    }

    let newSavedPercentage = matchingSitecode.discount_percentage * 100;

    if (this.compareAtPrice && this.compareAtPrice > newProductPrice) {
      newSavedPercentage = (newProductPrice / this.compareAtPrice) * 100;
      newSavedPercentage = Math.round(newSavedPercentage);
      newSavedPercentage = 100 - newSavedPercentage;
    }

    const savePercentageEl = this.querySelector(
      ".product-compare-at-price-container__percentage",
    );
    if (savePercentageEl) {
      savePercentageEl.textContent = "-" + newSavedPercentage + "%";
    }

    this.updateCardDiscountBadge(newProductPrice);
  }

  // The sale badge sits next to the gift tag in the card header, outside
  // <product-price>, so it has to be reached through the card wrapper. It
  // mirrors the merged compare-at + sitecode percentage that
  // snippets/sitecode-default-discount.liquid renders server-side for a
  // default sitecode — measured off the compare-at price, so it stays in step
  // with the strikethrough and sale price this method just wrote.
  updateCardDiscountBadge(newProductPrice) {
    const badge = this.closest("product-card")?.querySelector(
      ".product-badge-custom-compare-at-price",
    );

    if (!badge || !badge.dataset.labelTemplate) {
      return;
    }

    const compareAtPrice =
      this.compareAtPrice > this.originalPrice
        ? this.compareAtPrice
        : this.originalPrice;

    const percentage = Math.round(
      (1 - newProductPrice / compareAtPrice) * 100,
    );

    if (percentage <= 5 || percentage === 100) {
      badge.dataset.active = "false";
      return;
    }

    badge.dataset.perc = percentage;
    badge.dataset.active = "true";
    badge.textContent =
      badge.dataset.labelTemplate.replace("__PERC__", percentage) + "%";
  }
}

customElements.define("product-price", ProductPrice);

if (!customElements.get("countdown-timer")) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.numbers = [...this.querySelectorAll(".countdown-timer__number")];
      this.countdownTimer = this.calculateInitialTime();
      this.startTimer();
    }

    // Method to calculate the remaining time based on the target time and current time (in seconds)
    calculateInitialTime() {
      const currentTime = Math.floor(Date.now() / 1000); // Get the current time in seconds
      const endTime = parseInt(this.dataset.timer, 10); // Parse the timer value from the dataset
      return endTime - currentTime; // Return the difference (remaining time in seconds)
    }

    // Method to start the countdown and set up an interval to update every second
    startTimer() {
      this.updateDisplay(); // Immediately update the display with the current time
      this.intervalId = setInterval(() => {
        this.countdownTimer--; // Decrease the countdown time by 1 second
        this.updateDisplay(); // Update the displayed time
        this.checkTimerEnd(); // Check if the countdown has reached 0
      }, 1000); // Set interval to 1 second
    }

    // Method to update the displayed time in days, hours, minutes, and seconds
    updateDisplay() {
      const [days, hours, minutes, seconds] = this.calculateTimeUnits(); // Calculate time units from countdown
      // Update the corresponding elements with the calculated values
      [days, hours, minutes, seconds].forEach((unit, i) => {
        this.numbers[i].textContent = unit;
      });
    }

    // Method to calculate the time units (days, hours, minutes, seconds) from the countdown time
    calculateTimeUnits() {
      const days = Math.floor(this.countdownTimer / (60 * 60 * 24)); // Calculate remaining days
      const hours = Math.floor(
        (this.countdownTimer % (60 * 60 * 24)) / (60 * 60),
      ); // Calculate remaining hours
      const minutes = Math.floor((this.countdownTimer % (60 * 60)) / 60); // Calculate remaining minutes
      const seconds = this.countdownTimer % 60; // Calculate remaining seconds
      return [days, hours, minutes, seconds]; // Return the time units as an array
    }

    // Method to check if the countdown has reached zero and clear the interval if so
    checkTimerEnd() {
      if (this.countdownTimer <= 0) {
        clearInterval(this.intervalId); // Stop the countdown once it reaches zero
      }
    }
  }

  // Define the custom element 'countdown-timer' using the CountdownTimer class
  customElements.define("countdown-timer", CountdownTimer);
}

if (!customElements.get("klaviyo-subscription-form")) {
  class KlaviyoSubscriptionForm extends HTMLElement {
    constructor() {
      super();

      this.firstNameInput = this.querySelector("#FirstName");
      this.emailInput = this.querySelector(".footer-newsletter__input--email");
      this.emailLabel = this.querySelector("label[for='EmailContact']");
      this.acceptsMarketingInput = this.querySelector("#AcceptsMarketing");
      this.acceptsMarketingLabel = this.querySelector(
        ".footer-newsletter__consent-label",
      );
      this.firstNameInput = this.querySelector("#FirstName");
      this.submitButton = this.querySelector(".footer-newsletter__submit");

      this.submitButton.addEventListener("click", this.handleSubmit.bind(this));
    }

    evaluateInput() {
      let valid = true;

      if (
        this.emailInput.value === "" ||
        !this.emailInput.value.includes("@")
      ) {
        this.emailLabel.classList.add("footer-newsletter__label--invalid");
        valid = false;
      } else {
        this.emailLabel.classList.remove("footer-newsletter__label--invalid");
      }

      if (this.acceptsMarketingInput.checked == false) {
        this.acceptsMarketingLabel.classList.add(
          "footer-newsletter__label--invalid",
        );
        valid = false;
      } else {
        this.acceptsMarketingLabel.classList.remove(
          "footer-newsletter__label--invalid",
        );
      }

      return valid;
    }

    async handleSubmit(event) {
      const valid = this.evaluateInput();

      if (!valid) {
        return;
      }

      await fetch(
        `https://paurish.com/yotpo-loyalty-newsletter?email=${this.emailInput.value}`,
      );

      const profileAttributes = {
        email: this.emailInput.value,
      };

      if (this.firstNameInput.value !== "") {
        profileAttributes["first_name"] = this.firstNameInput.value;
      }

      let listId = null;

      if (window.Shopify.locale.toLowerCase().includes("de")) {
        listId = "VzXBep";
      } else {
        listId = "Xdu4V6";
      }

      const body = {
        data: {
          type: "subscription",
          attributes: {
            custom_source: "footer",
            profile: {
              data: {
                type: "profile",
                attributes: profileAttributes,
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: listId,
              },
            },
          },
        },
      };

      const options = {
        method: "POST",
        headers: {
          revision: "2026-04-15",
          accept: "application/vnd.api+json",
          "content-type": "application/vnd.api+json",
        },
        body: JSON.stringify(body),
      };

      const klaviyoFetch = await fetch(
        "https://a.klaviyo.com/client/subscriptions?company_id=Ubfdhc",
        options,
      );

      if (klaviyoFetch.ok) {
        this.setAttribute("data-state", "success");
      } else {
        alert("An error occured. Please try again later.");
      }
    }
  }
  customElements.define("klaviyo-subscription-form", KlaviyoSubscriptionForm);
}

if (!customElements.get("variant-overlay")) {
  const STELLA_LINK_MESSAGE_SELECTOR = "[data-stella-link-message]";
  const STELLA_MATCH_MESSAGE_SELECTOR = "[data-stella-match-message]";
  const STELLA_VARIANT_ID = "STELLA_AI";

  // The selected-shade preview mirrors whatever the picked switch shows. A
  // swatch is a flat colour, a shade image or the Stella gradient
  // (see snippets/variant-swatch-style.liquid), so every background longhand
  // the switch carries is copied rather than just its colour.
  const copySwatchBackground = (from, to) => {
    to.style.background = "";
    to.style.backgroundColor = from.style.backgroundColor;
    to.style.backgroundImage = from.style.backgroundImage;
    to.style.backgroundSize = from.style.backgroundSize;
    to.style.backgroundPosition = from.style.backgroundPosition;
  };

  class VariantOverlay extends HTMLElement {
    constructor() {
      super();

      this.sticky = this.dataset.sticky === "true";
      this.switches = this.querySelectorAll(".variant-overlay__bottom-switch");
      this.topSelectedCollapsibleBtn = this.querySelector(
        ".variant-overlay__top-selected",
      );
      this.topSelectedSwitch = this.querySelector(
        ".variant-overlay__top-selected-switch",
      );
      this.prices = this.querySelectorAll(".variant-overlay__top-atc-price");
      this.colorSwitches = this.dataset.colorSwitches === "true";
      this.atcButton = this.querySelector(".variant-overlay__top-atc");
      this.closeButton = this.querySelector(
        ".variant-overlay__selection-close",
      );
      this.variantCount = parseInt(this.dataset.variantCount);
      this.backgroundEl = document.querySelector(
        `.variant-overlay__background[data-product-id='${this.dataset.productId}']`,
      );

      this.applyDefaultStellaLabel();
      this.registerListeners();
      this.populateStellaLabels();
    }

    scrollToActiveVariant() {
      const currentActiveSwitch = this.querySelector([
        '[data-switch][data-active="true"]',
      ]);
      if (currentActiveSwitch) {
        this.scrollToSwitch(currentActiveSwitch);
      }
    }

    populateStellaLabels() {
      this.querySelectorAll(".product-options__label-stella").forEach(
        (stellaIcon, index) => {
          if (variantIdRecommendedByStella(stellaIcon.dataset.variantId)) {
            stellaIcon.dataset.stellaSelected = true;
          }
        },
      );
    }

    switchStellaMessages(showElementSelector) {
      const allStellaMatchMessageElsSelectors = [
        STELLA_LINK_MESSAGE_SELECTOR,
        STELLA_MATCH_MESSAGE_SELECTOR,
      ];

      allStellaMatchMessageElsSelectors.forEach((selector) => {
        const stellaMatchMessageEls = this.querySelectorAll(selector);
        stellaMatchMessageEls.forEach((stellaMatchMessageEl) => {
          stellaMatchMessageEl.dataset.show =
            showElementSelector === selector ? "true" : "false";
        });
      });
    }

    applyDefaultStellaLabel() {
      const currentVariantId = this.getCurrentActiveVariantId();
      if (!currentVariantId) {
        return;
      }

      if (variantIdRecommendedByStella(currentVariantId)) {
        this.switchStellaMessages(STELLA_MATCH_MESSAGE_SELECTOR);
      }
    }

    registerListeners() {
      this.switches.forEach((switchButton) => {
        switchButton.addEventListener("click", (e) => {
          const variantId = switchButton.dataset.variantId;
          this.selectVariant(variantId);
          this.scrollToSwitch(switchButton);
        });
      });

      this.atcButton.addEventListener("click", (e) => {
        const currentVariant = this.getCurrentVariant();
        if (currentVariant.variantAvailable) {
          addToCartOpenDrawer(currentVariant.variantId, 1);
          this.closeAction();
        } else {
          // Sold-out variant selected: the button now reads "Remind me" — send
          // the shopper to the product page instead of adding to cart.
          const productUrl = this.dataset.productUrl;
          if (productUrl) {
            window.location.href = productUrl;
          }
        }
      });

      if (this.sticky) {
        if (this.variantCount > 1) {
          this.topSelectedCollapsibleBtn.addEventListener("click", (e) => {
            this.toggleCollapsible();
          });
        }

        this.initMutationObserver();
      }
      this.closeButton.addEventListener("click", (e) => {
        this.closeAction();
      });
    }

    // Hide on sticky mode, collapse on non-sticky mode
    closeAction() {
      if (this.sticky) {
        if (this.dataset.collapsibleState === "true") {
          this.toggleCollapsible();
        }
      } else {
        if (this.dataset.show === "true") {
          this.toggleShow();
        }
      }
    }

    toggleCollapsible() {
      const currentCollapsibleState = this.dataset.collapsibleState === "true";
      this.setAttribute("data-collapsible-state", !currentCollapsibleState);
      this.scrollToActiveVariant();
    }

    show() {
      if (this.dataset.show === "transition") return;
      if (!this.sticky) {
        this.backgroundEl.dataset.show = "true";
      }
      this.setAttribute("data-show", "transition");
      setTimeout(() => {
        this.setAttribute("data-show", "true");
      }, 10);
    }

    hide() {
      if (this.dataset.show === "transition") return;
      if (!this.sticky) {
        this.backgroundEl.dataset.show = "false";
      }
      this.setAttribute("data-show", "transition");
      setTimeout(() => {
        this.setAttribute("data-show", "false");
      }, 300);
    }

    toggleShow() {
      if (this.dataset.show === "transition") return;
      const currentShowState = this.dataset.show === "true";
      if (currentShowState) {
        this.hide();
      } else {
        this.show();
      }
    }

    scrollToSwitch(switchButton) {
      const list = switchButton.closest(".variant-overlay__bottom-switches");
      if (!list) return;
      const listRect = list.getBoundingClientRect();
      const btnRect = switchButton.getBoundingClientRect();
      const offset =
        btnRect.left -
        listRect.left +
        list.scrollLeft -
        listRect.width / 2 +
        btnRect.width / 2;
      list.scrollTo({ left: offset, behavior: "smooth" });
    }

    getElsForVariant(variantId) {
      const switchBtn = Array.from(this.switches).find(
        (switchButton) =>
          parseInt(switchButton.dataset.variantId) == parseInt(variantId) ||
          switchButton.dataset.variantId === STELLA_VARIANT_ID, // For stella variant, return the switch button with stella label (if exists)
      );
      const price = Array.from(this.prices).find(
        (price) =>
          parseInt(price.dataset.variantId) == parseInt(variantId) ||
          price.dataset.variantId === STELLA_VARIANT_ID, // For stella variant, return the price with stella label (if exists)
      );
      return {
        switchBtn: switchBtn,
        priceEl: price,
      };
    }

    getCurrentVariant() {
      const currentVariantId = this.getCurrentActiveVariantId();
      const { priceEl } = this.getElsForVariant(currentVariantId);
      return {
        variantId: currentVariantId,
        variantTitle: priceEl.dataset.variantTitle,
        variantAvailable: priceEl.dataset.available === "true",
      };
    }

    getCurrentActiveVariantId() {
      const currentActiveSwitch = this.querySelector(
        '[data-switch][data-active="true"]',
      );
      if (currentActiveSwitch) {
        return currentActiveSwitch.dataset.variantId;
      }

      // Single-variant products render no switches at all — the whole
      // selection wrapper sits behind {% if variant_count > 1 %} — so fall
      // back to the active price, which the overlay always renders.
      return this.querySelector(
        '.variant-overlay__top-atc-price[data-active="true"]',
      )?.dataset.variantId;
    }

    selectVariant(variantId) {
      const { switchBtn: oldSwitchBtn, priceEl: oldPriceEl } =
        this.getElsForVariant(this.getCurrentActiveVariantId());
      oldSwitchBtn.dataset.active = false;
      if (oldPriceEl) {
        oldPriceEl.dataset.active = false;
      }

      const { switchBtn: newSwitchBtn, priceEl: newPriceEl } =
        this.getElsForVariant(variantId);
      const newVariantTitle = newSwitchBtn.dataset.variantTitle;

      newSwitchBtn.dataset.active = true;
      if (newPriceEl) {
        newPriceEl.dataset.active = true;
      }
      this.querySelector("[data-selected-variant-title]").textContent =
        newVariantTitle;

      if (String(variantId) === STELLA_VARIANT_ID) {
        copySwatchBackground(newSwitchBtn, this.topSelectedSwitch);
        return this.switchStellaMessages(STELLA_LINK_MESSAGE_SELECTOR);
      }

      if (this.colorSwitches) {
        const stellaMessageSelector = !!newSwitchBtn.querySelector(
          "[data-stella-selected='true']",
        )
          ? STELLA_MATCH_MESSAGE_SELECTOR
          : "";
        this.switchStellaMessages(stellaMessageSelector);
        copySwatchBackground(newSwitchBtn, this.topSelectedSwitch);
      } else {
        this.topSelectedSwitch.textContent = newVariantTitle;
      }

      const variantAvailable = this.getCurrentVariant().variantAvailable;

      this.atcButton.dataset.available = variantAvailable;

      this.dispatchEvent(
        new CustomEvent("variant-selected", {
          detail: {
            variantId: variantId,
          },
        }),
      );
    }

    selectStellaVariant() {
      const { switchBtn: oldSwitchBtn } = this.getElsForVariant(
        this.getCurrentActiveVariantId(),
      );
      oldSwitchBtn.dataset.active = false;
    }

    initMutationObserver() {
      this.atcObserver = new IntersectionObserver(
        (entries) => {
          const currentScrollTop =
            document.documentElement.scrollTop || document.body.scrollTop;

          const minScrollTop = window.screen.width < 800 ? 1000 : 700;

          if (currentScrollTop < minScrollTop) {
            this.hide();
            return;
          }

          if (entries[0].isIntersecting) {
            this.hide();
          } else {
            this.show();
          }
        },
        {
          root: null,
          rootMargin: "0px",
          threshold: 0.0,
        },
      );

      this.observeProductFormAtc();
    }

    // The button lives inside .product-form__cta-container, whose innerHTML is
    // replaced wholesale on every variant change (see product-form.js), which
    // detaches the observed node and leaves the sticky bar stuck. Call this
    // again after each re-render to pick up the fresh button.
    observeProductFormAtc() {
      if (!this.atcObserver) return;

      const atcButton = document.querySelector(
        ".product-form__add-to-cart.button[data-action='add-to-cart']",
      );
      // Sold-out and coming-soon products render a different button entirely,
      // so there is nothing to track against.
      if (!atcButton) return;

      this.atcObserver.disconnect();
      this.atcObserver.observe(atcButton);
    }
  }

  // Product cards no longer open the overlay, but merchant-authored content can
  // still call this, and the PDP keeps the overlay itself.
  function openVariantOverlay(productId) {
    const variantOverlay = document.querySelector(
      `variant-overlay[data-product-id="${productId}"]`,
    );
    variantOverlay?.show();
  }

  customElements.define("variant-overlay", VariantOverlay);
}

class CustomYotpoRating extends HTMLElement {
  constructor() {
    super();

    this.productId = this.dataset.productId;
    this.yotpoAppKey = "EDc1vj8PTmjuHuo0cUBNf3lXQbrV6sAyTLXRuqBM";

    this.ratingEl = this.querySelector("[data-rating]");
    this.countEl = this.querySelector("[data-rating-count]");

    this.populate();
  }

  async fetchYotpo() {
    const fetchRes = await fetch(
      `https://api.yotpo.com/products/EDc1vj8PTmjuHuo0cUBNf3lXQbrV6sAyTLXRuqBM/${this.productId}/bottomline`,
    );
    if (!fetchRes.ok) {
      return null;
    }
    const fetchResJson = await fetchRes.json();
    return {
      rating_score: fetchResJson.response.bottomline.average_score,
      rating_count: fetchResJson.response.bottomline.total_reviews,
    };
  }

  async populate() {
    const yotpoData = await this.fetchYotpo();
    if (!yotpoData || yotpoData.rating_count === 0) {
      this.setAttribute("data-show", false);
      return;
    }
    this.ratingEl.textContent = yotpoData.rating_score;
    this.countEl.textContent = yotpoData.rating_count;
    this.setAttribute("data-loaded", true);
  }
}

customElements.define("custom-yotpo-rating", CustomYotpoRating);

function userDidStellaQuiz() {
  try {
    if (localStorage.getItem("stellaRecommendedProductVariants")) {
      const stellaData = JSON.parse(
        localStorage.getItem("stellaRecommendedProductVariants") || [],
      );
      return stellaData.length != 0;
    }
    if (localStorage.getItem("askStellaAnalysisData")) {
      const stellaData = JSON.parse(
        localStorage.getItem("askStellaAnalysisData") || [],
      );
      return stellaData.length != 0;
    }
    return false;
  } catch (e) {
    return false;
  }
}

function variantIdRecommendedByStella(variantId) {
  if (!userDidStellaQuiz()) {
    return false;
  }

  // Stella V2
  if (localStorage.getItem("stellaRecommendedProductVariants")) {
    const stellaData = JSON.parse(
      localStorage.getItem("stellaRecommendedProductVariants") || [],
    );
    const containsVariantId = stellaData.some((variant) => {
      return variant.variant_id.toString() === variantId.toString();
    });
    return containsVariantId;
  }

  // Stella V1

  if (localStorage.getItem("askStellaAnalysisData")) {
    const stellaData = JSON.parse(
      localStorage.getItem("askStellaAnalysisData") || [],
    );
    const stellaQuizObject = stellaData[0];
    const stellaQuizVariantIds = stellaQuizObject.products.map((product) => {
      return product.variant_id.toString();
    });
    return stellaQuizVariantIds.includes(variantId.toString());
  }

  return false;
}

// Pass stella add to cart request to theme
document.addEventListener("stellaRerenderCart", () => {
  openCartDrawerV2();
});

document.addEventListener("stella-add-to-cart", (event) => {
  const data = { items: event.detail.items };
  data.items.forEach((item) => {
    addToCartOpenDrawer(item.id, item.quantity);
  });
});

// Set CSS variable for header height
function setHeaderHeight() {
  const header = document.querySelector("header");
  if (header) {
    const headerHeight = header.offsetHeight;
    document.documentElement.style.setProperty(
      "--header-height",
      `${headerHeight}px`,
    );
  }
}

// Set header height on load and resize
setHeaderHeight();
window.addEventListener("resize", setHeaderHeight);
